import { render, staticRenderFns } from "./OnboardingReviewAndTestStore.vue?vue&type=template&id=26b4460d"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports